import { render } from "./OturumSuresiBitti.vue?vue&type=template&id=7ba090e6&scoped=true"
import script from "./OturumSuresiBitti.vue?vue&type=script&lang=js"
export * from "./OturumSuresiBitti.vue?vue&type=script&lang=js"

import "./OturumSuresiBitti.vue?vue&type=style&index=0&id=7ba090e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cosku\\OneDrive\\Masaüstü\\DiyetisyenYagmurDemir\\GT Yönetim Sistemi - Kopya\\Yönetim Sistemi - Frontend\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba090e6"]])

export default __exports__